/** @jsxImportSource @emotion/react */
import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import { jsx, css, keyframes } from "@emotion/react";
import pr from "../lib/pr";
import {
  Grid,
  Box,
  TextField,
  Badge,
  Typography,
  Dialog,
  Button,
  Paper,
  Divider,
  SwipeableDrawer,
} from "@mui/material";
import styled from "@emotion/styled";
import add_comma from "../lib/add_comma";
import queryString from "query-string";
import get_token from "../lib/get_token";
import { loginState, configState } from "../lib/State";
import axios from "axios";
import Swal from "sweetalert2";
import get_cid from "../lib/get_cid";

const HomeCalorie = forwardRef((props, ref) => {
  const { login } = props;
  let { flag } = queryString.parse(window.location.search);
  flag = flag !== undefined ? true : false;
  const [open, setOpen] = useState(flag);
  const [loaded, setLoaded] = useState(false);
  const [cid, setCid] = useState(get_cid());
  const [openUse, setOpenUse] = useState(false);

  // 부모창에서 자식함수 호출할때 (자식창에있는 대화상자 오픈)
  useImperativeHandle(ref, () => ({
    open() {
      setOpen(true);
      load_data();
      count_data();
    },
  }));

  const [clicked, setClicked] = useState(false);
  const [rows, setRows] = useState([]);
  const token = get_token();
  let result;

  const [count, setCount] = useState("-");

  const closeClick = () => {
    setOpen(false);
    load_data();
  };

  const load_data = async () => {
    let result;
    const postData = {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
    };
    result = await axios.post(configState.api + "/hr/get_kcal_log", postData);
    if (result.data.success === 1) {
      setRows(result.data.rows);
    }
    setLoaded(true);
  };

  const count_data = async () => {
    let postData = {
      token: get_token(),
      mcd: login.mcd,
      level: login.level,
      cid: cid,
    };
    let result = await axios.post(
      configState.api + "/hr/get_kcal_all",
      postData
    );
    setCount(result.data.amount);
  };

  const [currentDate, setCurrentDate] = useState(
    new Date().toISOString().slice(0, 7)
  );
  const [date, setDate] = useState(new Date().toISOString().slice(0, 7));
  const chageDate = (e) => {
    const direction = e.currentTarget.attributes.direction.value;
    let mounth = +date.slice(5, 7);
    let year = +date.slice(0, 4);
    if (direction === "prev") {
      mounth--;
      if (mounth <= 0) {
        mounth = 12;
        year -= 1;
      }
    } else {
      mounth++;
      if (mounth > 12) {
        mounth = 1;
        year += 1;
      }
    }
    mounth = ("0" + mounth).slice(-2);
    setDate(year + "-" + mounth);
  };

  return (
    <>
      <Dialog fullScreen open={open} onClose={closeClick}>
        <Box>
          {/* 상단 */}
          <Box
            sx={{
              width: "90%",
              textAlign: "left",
              padding: "30px 0 10px 10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <img src="/img/back_button_black.png" onClick={closeClick} />
            <Box
              sx={{
                width: "100%",
                margin: "25px 0 0 10px",
                fontSize: "22px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
              }}
            >
              <Box>누적칼로리내역</Box>
            </Box>
          </Box>
          <Divider />
          <Box sx={{ pt: 3 }}></Box>

          <div className="flex w-full justify-between mt-3 mb-10 px-10">
            <div direction="prev" onClick={chageDate}>
              <img
                src="/img/next.svg"
                className="w-7 rotate-180 opacity-50"
                alt=""
              />
            </div>
            <p className="text-2xl font-bold opacity-80">{date}</p>
            {currentDate !== date ? (
              <div direction="next" onClick={chageDate}>
                <img src="/img/next.svg" className="w-7 opacity-50" alt="" />
              </div>
            ) : (
              <div className="w-7" />
            )}
          </div>

          {/* 하단 */}
          <Box>
            <Box fontSize="16px" textAlign="right" width="90%">
              총소모: {add_comma(count)}칼로리
            </Box>
            {loaded &&
              rows.filter((x) => x.pdate.slice(0, 7) === date).length === 0 && (
                <Box
                  sx={{
                    height: cid === "XXXXX" /*줌*/ ? "28rem" : "80vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  누적칼로리내역이 없습니다.
                </Box>
              )}
            {rows.map(
              (item, index) =>
                item.pdate.slice(0, 7) === date && (
                  <Box
                    key={index}
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: "90%",
                        display: "flex",
                        justifyContent: "flex-start",
                        padding: "0 0 5px 2.5%",
                        fontSize: "13px",
                        color: "#979797",
                        fontWeight: "bold",
                      }}
                    >
                      <Box>{item.pdate}</Box>
                    </Box>
                    <Box
                      sx={{
                        width: "84%",
                        border: "1px solid #dcdddd",
                        padding: "10px",
                        // marginBottom: '15px',
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          aligntItems: "center",
                          marginLeft: "10px",
                        }}
                      >
                        <img
                          src="/img/calories.png"
                          style={{
                            width:
                              cid === "XXXXX" /*줌*/ ? "4rem" : "15vw",
                          }}
                        />
                      </Box>
                      <Box
                        sx={{
                          marginLeft: "10px",
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: "15px",
                            color: "#999999",
                            fontWeight: "500",
                            width: "100%",
                          }}
                        >
                          {add_comma(item.amount)}칼로리 소모했습니다.
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )
            )}
          </Box>
          <Box sx={{ pt: 6 }}></Box>
        </Box>
      </Dialog>
    </>
  );
});

export default HomeCalorie;
